<div class="talent-pool-item">
  <common-mojo-card
    [elevation]="elevation"
    mojoContainerQuery
    xlSize='950'
  >
    <div class="container-header">
      <span
        [routerLink]="['/talent-pools', talentPool.id]"
        class="talent-name"
      >{{talentPool.name}} </span>
      <mojo-dropdown-menu-with-icons
        [width]="'10rem'"
        [xPosition]="'before'"
        class="aside-buttons-on-hover"
        [targetId]="talentPool.id"
        [parameters]="{ page: page, numberOfElements: numberOfElements}"
        [menuItems]="menuItems"
      ></mojo-dropdown-menu-with-icons>
      <span
        [ngClass]="talentPool.pin ? 'pinned-pool-icon  material-icons' : 'unpin-pool-icon material-icons-outlined'"
        matTooltip
        [matTooltip]="talentPool.pin ? 'Unpin from the top' : 'Pin to the top'"
        (click)="pinPool()"
      >
        push_pin
      </span>
    </div>

    <div class="pools-info">
      <mat-icon class="pools-info-icon">person</mat-icon>
      <div class="pools-info-text pr-4">{{talentPool.candidateSize}} talents
      </div>
      <ng-container *ngIf="talentPool.privateTalentPool; else public">
        <mat-icon class="pools-info-icon">https</mat-icon>
        <div class="pools-info-text">Private</div>
      </ng-container>
      <ng-template #public>
        <mat-icon class="pools-info-icon">remove_red_eye</mat-icon>
        <div class="pools-info-text">Public</div>
      </ng-template>
    </div>
  </common-mojo-card>
</div>
